

export interface MaintenanceSchedulerModel {
    id: number;
    title: string;
}

export const maintenanceOptions: MaintenanceSchedulerModel[] = [
  {
    id: 1,
    title: 'Preventive Maintenance'
  },
  {
    id: 2,
    title: 'Corrective Maintenance'
  },
  {
    id: 3,
    title: 'Testing'
  },
];
